import * as types from "./types";
import * as mutation_types from "./mutation_types";
import {
    Get
} from "./api/methods";
import Vue from 'vue'

export default {
    [types.A_TOUR_SEARCH](context, data) {
        context.state.tourSearchData = Object.assign({}, data);
        context.state.searchId++;

        let showCities = this.getters['getSettings'].IsShowFiltersByCity;
        const rate = JSON.parse(localStorage.getItem("Rate"));
        const stateParams = context.state.filterParams; //для сохранения квот в фильтрах
        const computedCityKey = data.resort && data.easySearchFilters ? "cityKeysOfResorts" : "citiesTo";

        let hotels =[];
        if(context.state.searchId>1)
        {   
            if(stateParams.tourHotel)
            {
                if(stateParams.tourHotel.length>0)
                {
                    hotels=stateParams.tourHotel.map(x => {
    
                        return x
                    })
                }  
            }
        }

        context.state.urlParams = `departureCities=${data.cities.map(x => x).join(",")}&` +
            `destination=1_${data.countryTo}&` +
            (showCities ? `destCities=${data.citiesTo.map(x => x).join(",")}&` : "") +
            `tourType=${data.tourType.join(",")}&` +
            `dates=${data.date.join(",")}&` +
            `durations=${data.days.join(",")}&` +
            `adultCount=${data.adultCount}&` +
            (data.children.length ? `childAges=${data.children.map(x => x.age).join(",")}&` : "") +
            `aviaQuota=${stateParams.aviaQuota}&` +
            `hotelQuota=${stateParams.hotelQuota}&` +
            `busTransferQuota=${stateParams.busTransferQuota}&` +
            `trainTransferQuota=${stateParams.railwayTransferQuota}&` +
            `currency=${rate.IsoCode}` +
            (data.easySearchFilters && data.city !== -1 ? `&comboSearch${data.city ? 'City' : data.hotel ? 'Hotel' : 'Resort'}=true` : "") +
            (data.hotel ? `&hotels=${data.hotel}` : "") +
            (data.resort ? `&resorts=${data.resort}` : "") +
            (data.city && data.city !== -1 ? `&cities=${data.city}` : "");
        let sendParams = context.state.API_URL + "TourForWeb/search/simple?" +
            data.cities.map(x => `DepartureCityKeys=${x}`).join("&") + "&" +
            data.date.map(x => `Dates=${x}`).join("&") + "&" +
            data.days.map(x => `Durations=${x}`).join("&") + "&" +
            `PageNumber=${data.page}&` +
            `PageSize=${data.perPage}&` +
            "HotelScheme=&TourKey=&TourDuration=&ShowToursWithoutHotels=-1&isFromBasket=false&isFillSecondaryFilters=false&DestinationType=1&" +
            "DestinationKey=" + data.countryTo + "&" +
            `AdultCount=${data.adultCount}` + "&" +
            data.children.map(x => `ChildAges=${x.age}`).join("&") + "&" +
            `CurrencyName=${rate.Code}&` +
            `AviaQuota=${stateParams.aviaQuota}&` +
            `HotelQuota=${stateParams.hotelQuota}&` +
            `BusTransferQuota=${stateParams.busTransferQuota}&` +
            `RailwayTransferQuota=${stateParams.railwayTransferQuota}&` +
            `${data.tourType.map(x => `TourType=${x}`).join("&")}&` +
            data[computedCityKey].map(x => `CityIds=${x}`).join("&") + "&" +
            (hotels.length>0 ? hotels.map(x => `Hotel=${x.Key}`).join("&") + "&" : "") +
            "TimeDepartureFrom=00:00&TimeDepartureTo=23:59&TimeArrivalFrom=00:00&TimeArrivalTo=23:59&" +
            `SearchId=${context.state.searchId}&` +
            "SearchMaxPriceAlgoritm=false&" +
            "MatrixAlgoritm=false&" +
            "wrongLicenseFileUpperTitle=Incorrect+license+file.&RemoteHotelMode=0&_=" + data.current;

        sendParams = sendParams.replace(/&&/g, "&");
        context.state.lastRequest = sendParams;
        context.state.mainRequest = sendParams;

        let firstQuestion = new Promise((resolve) => {
            // sendParams = encodeURI(sendParams);
            sendParams = sendParams.split("&")
                .filter(x => !x.includes("SearchMaxPriceAlgoritm"))
                .map(x => {
                    if (x.includes(":") && !x.includes("http")) {
                        // x = x.replace(":", "%3A")
                    }
                    return x
                })
                .join("&");

            Vue.Api.Get(sendParams)
                .then(res => {
                    context.state.searchResult = res.data.Result;
                    context.state.searchResult = context.state.searchResult.map(x => {
                        x.rate = {...rate};
                        return x
                    });
                    context.state.secondaryFiltersResult = res.data.SecondaryFiltersResult;
                    context.state.cashSecondaryFiltersResult = res.data.SecondaryFiltersResult;
                    resolve({
                        url: context.state.urlParams,
                        message: res.data.Message.Key
                    })
                });
        });
        let tourForWeb = sendParams
            .replace("MatrixAlgoritm=false", "MatrixAlgoritm=true")
            .replace("simple", "matrix");
        context.state.tourForWebParams = tourForWeb;
        context.state.mainSearchCount++;
        if (!window.settings.commonFilters || context.state.searchSecondParamsCounter === 0) context.state.showTourResultList = true; // Показываем результаты поиска
        context.state.searchSecondParamsCounter = 0;
        context.state.commonSearchFlag = false; // Нужно для проверки запуска функции commonSearch

        return new Promise((resolve, reject) => {
            Promise.all([firstQuestion])
                .then(res => {
                    let outSistem = false;
                    //Поиск из в.с.
                    if (res[0].message === 2 && context.state.searchInOut) {
                        context.state.outHotelMode = true;
                        outSistem = true
                    } else {
                        context.state.outHotelMode = false;
                    }

                    this.dispatch("tour/A_SET_SEARCHED", true);
                    context.commit(mutation_types.M_MAX_PRICE_IS_SET, false);
                    resolve({
                        result: res[0].url,
                        outSistem
                    });
                })
                .catch(err => {
                    context.state.searchResult = [];
                    this.dispatch("tour/A_SET_SEARCHED", true);
                    reject(err)
                })
        })
    },
    [types.A_TOUR_SEARCH_FOR_COMMON_FILTERS](context, data) {
        context.state.tourSearchData = Object.assign({}, data);
        context.state.searchId++;
        let showCities = this.getters['getSettings'].IsShowFiltersByCity;
        const rate = JSON.parse(localStorage.getItem("Rate"));
        const stateParams = context.state.filterParams; //для сохранения квот в фильтрах

        context.state.urlParams = `departureCities=${data.cities.map(x => x).join(",")}&` +
            `destination=1_${data.countryTo}&` +
            (showCities ? `destCities=${data.citiesTo.map(x => x).join(",")}&` : "") +
            `tourType=${data.tourType.join(",")}&` +
            `dates=${data.date.join(",")}&` +
            `durations=${data.days.join(",")}&` +
            `adultCount=${data.adultCount}&` +
            (data.children.length ? `childAges=${data.children.map(x => x.age).join(",")}&` : "") +
            `aviaQuota=${stateParams.aviaQuota}&` +
            `hotelQuota=${stateParams.hotelQuota}&` +
            `busTransferQuota=${stateParams.busTransferQuota}&` +
            `trainTransferQuota=${stateParams.railwayTransferQuota}&` +
            `currency=${rate.IsoCode}` +
            (data.easySearchFilters && data.city !== -1 ? `&comboSearch${data.city ? 'City' : data.hotel ? 'Hotel' : 'Resort'}=true` : "") +
            (data.hotel ? `&hotels=${data.hotel}` : "") +
            (data.resort ? `&resorts=${data.resort}` : "") +
            (data.city && data.city !== -1 ? `&cities=${data.city}` : "");

        let sendParams = context.state.API_URL + "TourForWeb/search/secondaryFilters?" +
            data.cities.map(x => `DepartureCityKeys=${x}`).join("&") + "&" +
            data.date.map(x => `Dates=${x}`).join("&") + "&" +
            data.days.map(x => `Durations=${x}`).join("&") + "&" +
            `PageNumber=${data.page}&` +
            `PageSize=${data.perPage}&` +
            "HotelScheme=&TourKey=&TourDuration=&ShowToursWithoutHotels=-1&isFromBasket=false&isFillSecondaryFilters=false&DestinationType=1&" +
            "DestinationKey=" + data.countryTo + "&" +
            `AdultCount=${data.adultCount}` + "&" +
            data.children.map(x => `ChildAges=${x.age}`).join("&") + "&" +
            `CurrencyName=${rate.Code}&` +
            `AviaQuota=${stateParams.aviaQuota}&` +
            `HotelQuota=${stateParams.hotelQuota}&` +
            `BusTransferQuota=${stateParams.busTransferQuota}&` +
            `RailwayTransferQuota=${stateParams.railwayTransferQuota}&` +
            `${data.tourType.map(x => `TourType=${x}`).join("&")}&` +
            data.citiesTo.map(x => `CityIds=${x}`).join("&") + "&" +
            "TimeDepartureFrom=00:00&TimeDepartureTo=23:59&TimeArrivalFrom=00:00&TimeArrivalTo=23:59&" +
            `SearchId=${context.state.searchId}&` +
            "SearchMaxPriceAlgoritm=false&" +
            "MatrixAlgoritm=false&" +
            "wrongLicenseFileUpperTitle=Incorrect+license+file.&RemoteHotelMode=0&_=" + data.current;

        sendParams = sendParams.replace(/&&/g, "&");
        context.state.lastRequest = sendParams;
        context.state.mainRequest = sendParams;

        let firstQuestion = new Promise((resolve) => {
            // sendParams = encodeURI(sendParams);
            sendParams = sendParams.split("&")
                .filter(x => !x.includes("SearchMaxPriceAlgoritm"))
                .map(x => {
                    if (x.includes(":") && !x.includes("http")) {
                        // x = x.replace(":", "%3A")
                    }
                    return x
                })
                .join("&");
            Vue.Api.Get(sendParams)
                .then(res => {
                    context.state.secondaryFiltersResult = res.data.SecondaryFiltersResult;
                    context.state.cashSecondaryFiltersResult = res.data.SecondaryFiltersResult;
                    resolve({
                        url: context.state.urlParams,
                    })
                });
        });

        let tourForWeb = sendParams
          .replace("MatrixAlgoritm=false", "MatrixAlgoritm=true")
          .replace("secondaryFilters", "matrix");
        context.state.tourForWebParams = tourForWeb;
        context.state.commonSearchFlag = true; // Нужно для проверки запуска функции commonSearch
        return new Promise((resolve, reject) => {
            Promise.all([firstQuestion])
                .then(res => {
                    let outSistem = false;
                    //Поиск из в.с.
                    if (res[0].message === 2 && context.state.searchInOut) {
                        context.state.outHotelMode = true;
                        outSistem = true
                    } else {
                        context.state.outHotelMode = false;
                    }

                    this.dispatch("tour/A_SET_SEARCHED", true);
                    context.commit(mutation_types.M_MAX_PRICE_IS_SET, false);
                    resolve({
                        result: res[0].url,
                        outSistem
                    });
                })
                .catch(err => {
                    context.state.searchResult = [];
                    this.dispatch("tour/A_SET_SEARCHED", true);
                    reject(err)
                })
        })
    },
    [types.A_GET_PRICE_TABLE](context, payload) {
        if (payload) return new Promise(resolve => resolve());

        context.state.priceTableData = [];
        context.state.priceTableDataCities = [];

        let tourForWeb = context.state.tourForWebParams
            .replace("RemoteHotelMode=2", "RemoteHotelMode=0");

        const durations = tourForWeb
            .split("&")
            .filter(x => x.includes("Durations"));
        let durationIndex = 0;


        const getPriceChunk = () => {
            return new Promise((resolve, reject) => {
                let isFirst = true;
                tourForWeb = tourForWeb.split("&");
                tourForWeb = tourForWeb
                    .filter(x => {
                        if (isFirst && x.includes("Durations")) {
                            isFirst = false;
                        } else if (x.includes("Durations")) {
                            return
                        }
                        return x
                    })
                    .map(x => {
                        if (x.includes("Durations")) {
                            return durations[durationIndex];
                        }
                        if (x.includes("CityIds")) {
                            return "CityIds=-1"
                        }
                        return x
                    });
                durationIndex++;
                tourForWeb = tourForWeb.join("&");
                Vue.Api.Get(tourForWeb)
                    .then(res => {
                        context.state.priceTableData = [...context.state.priceTableData, ...res.data.CellsForMatrix];
                        context.state.priceTableDataCities = [...context.state.priceTableDataCities, ...res.data.CitiesWithMinimalCosts];
                        if (durationIndex === durations.length) {
                            resolve(context.state.priceTableData)
                        } else {
                            getPriceChunk()
                                .then(() => {
                                    resolve(context.state.priceTableData)
                                })
                        }
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        };

        return new Promise((resolve, reject) => {
            getPriceChunk()
                .then(res => {
                    resolve(res)
                })
                .catch((err) => {
                    reject(err)
                })
        });
    },
    [types.A_GET_PRICE_TABLE_OUT_HOTEL](context) {
        let tourForWeb = context.state.tourForWebParams
            .replace("RemoteHotelMode=0", "RemoteHotelMode=2");

        const durations = tourForWeb
            .split("&")
            .filter(x => x.includes("Durations"));
        let durationIndex = 0;

        const getPriceChunk = () => {
            return new Promise((resolve, reject) => {
                let isFirst = true;
                tourForWeb = tourForWeb.split("&");
                tourForWeb = tourForWeb
                    .filter(x => {
                        if (isFirst && x.includes("Durations")) {
                            isFirst = false;
                        } else if (x.includes("Durations")) {
                            return
                        }

                        return x
                    })
                    .map(x => {
                        if (x.includes("Durations")) {
                            return durations[durationIndex];
                        }
                        if (x.includes("CityIds")) {
                            return "CityIds=-1"
                        }
                        return x
                    });
                durationIndex++;

                tourForWeb = tourForWeb.join("&");
                Vue.Api.Get(tourForWeb)
                    .then(res => {
                        /* Мерджим таблицу цен */
                        let oldPriceTable = [...context.state.priceTableData];
                        let newPriceTable = [...res.data.CellsForMatrix];
                        let allPriceTable = [...oldPriceTable];
                        newPriceTable.forEach(x => {
                            let helper = true;
                            oldPriceTable.forEach((x2, i2) => {
                                if (x2.Duration === x.Duration && x2.StartDate === x.StartDate) {
                                    helper = false;

                                    if (x.Cost < x2.Cost) {
                                        allPriceTable[i2] = {...x}
                                    }
                                }
                            });
                            if (helper) {
                                allPriceTable.push(x)
                            }
                        });
                        context.state.priceTableData = allPriceTable;
                        context.state.priceTableDataCities = [...context.state.priceTableDataCities, ...res.data.CitiesWithMinimalCosts];
                        if (durationIndex === durations.length) {
                            resolve(context.state.priceTableData)
                        } else {
                            getPriceChunk()
                                .then(() => {
                                    resolve(context.state.priceTableData)
                                })
                        }
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        };

        return new Promise((resolve, reject) => {
            getPriceChunk()
                .then(res => {
                    resolve(res)
                })
                .catch((err) => {
                    reject(err)
                })
        });
    },
    [types.A_GET_MAX_PRICE](context) {
        context.state.searchId++;

        return new Promise( (resolve, reject) => {
          let tourForWeb;
            //проверка на основной запрос поиска
            if (context.state.mainRequest.includes("simple")) {
              tourForWeb = context.state.mainRequest
              .replace("simple", "minMaxPrices")
              .replace("MatrixAlgoritm=false", "MatrixAlgoritm=true");
            } else {
                //проверка на запрос в доп. фильтрах (опция commonFilters)
                tourForWeb = context.state.mainRequest
                .replace("secondaryFilters", "minMaxPrices")
                .replace("MatrixAlgoritm=false", "MatrixAlgoritm=true");
              }

            Vue.Api.Get(tourForWeb)
                .then(res => {
                    let min = res.data.MinimalPrice;
                    let max = res.data.MaximalPrice;
                    context.commit(mutation_types.M_MAX_PRICE_IS_SET, true);

                    if (context.state.outHotelMode) {
                        let tourForWeb = context.state.mainRequest
                            .replace("simple", "minMaxPrices")
                            .replace("MatrixAlgoritm=false", "MatrixAlgoritm=true")
                            .replace("RemoteHotelMode=0", "RemoteHotelMode=2");

                        Vue.Api.Get(tourForWeb)
                            .then(res => {
                                let min2 = res.data.MinimalPrice;
                                let max2 = res.data.MaximalPrice;

                                let price = [];
                                price.push(min < min2 ? min : min2);
                                price.push(max > max2 ? max : max2);
                                resolve({
                                    price: price,
                                    isOutHotel: true
                                });
                            });
                    } else {
                        resolve({price: [min, max]});
                    }
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    [types.A_SEARCH_OUT_HOTEL](context, data) {
        const rate = JSON.parse(localStorage.getItem("Rate"));
        let sendParams = context.state.lastRequest;

        const hotelsFromUrl = data.hotelsFromUrl;
        const checkHotelsInParams = sendParams.includes("&Hotel=");
        if (hotelsFromUrl.length > 0 && !checkHotelsInParams) {
            sendParams = sendParams + "&" + hotelsFromUrl.map(x => `Hotel=${x}`).join("&");
        }

        sendParams = sendParams.replace("RemoteHotelMode=0", "RemoteHotelMode=2");
        let href = location.href.split("&");
        let indexCityTo = -1;
        href.forEach((x, i) => {
            if (x.includes("cityTo")) {
                indexCityTo = i
            }
        });
        if (indexCityTo !== -1) {
            let cityTo = href[indexCityTo].split("=")[1];
            sendParams = sendParams.split("&");
            sendParams = sendParams.map(x => {
                if (x.includes("CityIds")) {
                    x = `CityIds=${cityTo}`
                }
                return x
            });
            sendParams = sendParams.join("&");
        }

        let tourForWeb = sendParams
            .replace("simple", "matrix")
            .replace("MatrixAlgoritm=false", "MatrixAlgoritm=true");
        context.state.tourForWebParams = tourForWeb;

        let firstQuestion = new Promise((resolve, reject) => {
            sendParams = sendParams.split("&")
                .filter(x => !x.includes("SearchMaxPriceAlgoritm"))
                .join("&");
            const mainSearchCount = context.state.mainSearchCount;

            Vue.Api.Get(sendParams)
                .then(res => {
                    if (context.state.mainSearchCount !== mainSearchCount) {
                        resolve();
                        return
                    }

                    let resultGroup = [...context.state.searchResult, ...res.data.Result];
                    resultGroup = this.getters['quicksort'](resultGroup, "Cost");
                    resultGroup = resultGroup.map(x => {
                        x.rate = {...rate};
                        return x
                    });

                    let currentFilters = {...context.state.secondaryFiltersResult};
                    let newFilters = {...res.data.SecondaryFiltersResult};
                    let resultFilters = {};
                    for (let item in currentFilters) {
                        newFilters[item] = newFilters[item].filter(x => {
                            if (!currentFilters[item].map(x2 => x2.Key).includes(x.Key)) {
                                return x
                            }
                        });
                        let arr = [...currentFilters[item], ...newFilters[item]];
                        resultFilters[item] = arr
                    }
                    context.state.searchOutHotelFlag = true; // Флаг нужен, чтобы запускалась A_SET_SEARCH_SECOND_PARAMS после поиска внешних отелей в режиме commonFilters
                    resolve(
                        {
                            result: resultGroup,
                            resultFilters
                        }
                    )
                })
                .catch(err => {
                    reject(err)
                })
        });
        return new Promise((resolve, reject) => {
            Promise.all([firstQuestion])
                .then(res => {
                    context.state.searchResult = res[0].result;
                    context.state.secondaryFiltersResult = {...res[0].resultFilters};
                    context.state.cashSecondaryFiltersResult = {...res[0].resultFilters};
                    context.state.showTourResultList = true; // Показываем результаты поиска
                    resolve();
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    [types.A_SET_SEARCHED](context, payload) {
        context.commit(mutation_types.M_SET_SEARCHED, payload)
    },
    [types.A_SIGN_IN](context, payload) {
        let sendData = {
            userId: payload.login,
            password: payload.password,
        };

        return new Promise((resolve, reject) => {
            Vue.Api.Post(`${context.state.API_ORIGIN}${this.state.PATH}/Account/Login`, sendData)
                .then(res => {
                    const authKey = "CommonApplicationAuthCookie_.masterweblight-auth=";

                    let userInfo = document.cookie
                        .split(";")
                        .find(x => x.includes(authKey));
                    userInfo = userInfo.split(authKey)[1];
                    // Поправляем Summary
                    userInfo = JSON.parse(userInfo);
                    userInfo.Summary = encodeURIComponent(res.data.Identity.Summary);
                    document.cookie = `${authKey}${JSON.stringify(userInfo)}`;

                    context.state.userInfo = userInfo;
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    [types.A_LOGOUT](context) {
        context.state.userInfo = null;
        return new Promise(resolve => {
            Vue.Api.Post(`${context.state.API_ORIGIN}${this.state.PATH}/Account/Logout`)
                .then(() => {
                    document.cookie = "CommonApplicationAuthTokenCookie_.masterweblight-auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                    document.cookie = "CommonApplicationAuthCookie_.masterweblight-auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                    document.cookie = "CommonApplicationAuthCookie_.masterweblight-auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path="+this.state.PATH.slice(0,-1)+";";
                    resolve(true)
                })
        })
    },
    [types.A_GET_REGISTRATION_PASSWORD](context, user) {
        return new Promise((resolve) => {
            const date = new Date().getTime();
            const sendParams = `${context.state.API_URL}PersonalRegistration?name=${user.name}` +
                `&surname=${user.surname}` +
                `&phone=${user.phone}` +
                `&login=${user.login}` +
                `&password=${user.password}` +
                `&citizen=${user.citizen}` +
                `&country=${user.country}` +
                `&city=${user.city}` +
                `&address=${user.address}` +
                `&comment=${user.comment}` +
                `&captchaText=${user.captchaText}` +
                `&sessionId=${user.sessionId}&_=${date}`

            Vue.Api.Get(sendParams)
                .then(res => {
                    resolve(res.data)
                })
        })
    },
    [types.A_GET_REGISTRATION_NO_PASSWORD](context, user) {
        return new Promise((resolve) => {
            const date = new Date().getTime();
            const sendParams = `${context.state.API_URL}PersonalRegistration?name=${user.name}` +
                `&surname=${user.surname}` +
                `&phone=${user.phone}` +
                `&login=${user.login}&_=${date}`

            Vue.Api.Get(sendParams)
                .then(res => {
                    resolve(res.data)
                })
        })
    },
    [types.A_GET_PERSONAL_SEND_MAIL](context, user) {
        return new Promise((resolve) => {
            const date = new Date().getTime();
            const sendParams = `${context.state.API_URL}PersonalSendMail?mail=${user.mail}` +
                `&password=${user.password}` +
                `&dogovorCode=${user.dogovorCode}&_=${date}`

            Vue.Api.Get(sendParams)
                .then(res => {
                    resolve(res.data)
                })
        })
    },
    [types.A_RENDER_PRICE_TABLE](context) {
        let sendParams = context.state.tourForWebParams;
        const rate = JSON.parse(localStorage.getItem("Rate"));
        sendParams = sendParams.split("&").map(x => {
            if (x.includes("CurrencyName")) {
                x = `CurrencyName=${rate.Code}`
            }
            return x
        });

        sendParams = sendParams.join("&");
        return new Promise((resolve, reject) => {
            // sendParams = encodeURI(sendParams)
            Vue.Api.Get(sendParams)
                .then(res => {
                    context.state.priceTableData = res.data.CellsForMatrix;
                    context.state.priceTableDataCities = res.data.CitiesWithMinimalCosts;
                    resolve(res)
                })
                .catch((err) => {
                    reject(err)
                })
        });
    },
    [types.A_CHANGE_PRICE_TABLE_CITY](context, {from, to}) {
        let sendParams = context.state.tourForWebParams.split("?")[1].split("&");
        const rate = JSON.parse(localStorage.getItem("Rate"));

        sendParams = sendParams.map(x => {
            if (x.includes("CurrencyName")) {
                x = `CurrencyName=${rate.Code}`
            }
            return x;
        });

        if (from === -2 && to === -1) {
            sendParams.forEach((x, i) => {
                if (x.includes("CityIds")) {
                    sendParams[i] = null;
                }
            });
        } else if (from === -2) {
            let helper = false;
            sendParams.forEach((x, i) => {
                if (x.includes("CityIds") && !helper) {
                    sendParams[i] = `CityIds=${to}`;
                    helper = true;
                } else if (x.includes("CityIds")) {
                    sendParams[i] = null;
                }
            });
        } else if (to === -1) {
            let helper = false;
            sendParams.forEach((x, i) => {
                if (x.includes("DepartureCityKeys") && !helper) {
                    sendParams[i] = `DepartureCityKeys=${from}`;
                    helper = true;
                } else if (x.includes("DepartureCityKeys")) {
                    sendParams[i] = null;
                }
            });
        } else {
            let helperTo = false;
            let helperFrom = false;

            sendParams.forEach((x, i) => {
                if (x.includes("CityIds") && !helperTo) {
                    sendParams[i] = `CityIds=${to}`;
                    helperTo = true;
                } else if (x.includes("CityIds")) {
                    sendParams[i] = null;
                }
                if (x.includes("DepartureCityKeys") && !helperFrom) {
                    sendParams[i] = `DepartureCityKeys=${from}`;
                    helperFrom = true;
                } else if (x.includes("DepartureCityKeys")) {
                    sendParams[i] = null;
                }
            });
        }
        sendParams = sendParams.filter(x => x);
        sendParams = context.state.tourForWebParams.split("?")[0] + "?" + sendParams.join("&");
        sendParams = sendParams.replace("RemoteHotelMode=2", "RemoteHotelMode=0");

        const durations = sendParams
            .split("&")
            .filter(x => x.includes("Durations"));
        let durationIndex = 0;

        const getPriceChunk = () => {
            return new Promise((resolve, reject) => {
                let isFirst = true;
                sendParams = sendParams.split("&");
                sendParams = sendParams
                    .filter(x => {
                        if (isFirst && x.includes("Durations")) {
                            isFirst = false;
                        } else if (x.includes("Durations")) {
                            return
                        }
                        return x
                    })
                    .map(x => {
                        if (x.includes("Durations")) {
                            return durations[durationIndex];
                        }
                        return x
                    });
                durationIndex++;

                sendParams = sendParams.join("&");
                Vue.Api.Get(sendParams)
                    .then(res => {
                        /* Мерджим таблицу цен */
                        let oldPriceTable = [...context.state.priceTableData];
                        let newPriceTable = [...res.data.CellsForMatrix];
                        let allPriceTable = [...oldPriceTable];
                        newPriceTable.forEach(x => {
                            let helper = true;
                            oldPriceTable.forEach((x2, i2) => {
                                if (x2.Duration === x.Duration && x2.StartDate === x.StartDate) {
                                    helper = false;

                                    // if (x.Cost < x2.Cost) {
                                    allPriceTable[i2] = {...x}
                                    // }
                                }
                            });
                            if (helper) {
                                allPriceTable.push(x)
                            }
                        });
                        context.state.priceTableData = allPriceTable;

                        if (durationIndex === durations.length) {
                            resolve(context.state.priceTableData)
                        } else {
                            getPriceChunk()
                                .then(() => {
                                    resolve(context.state.priceTableData)
                                })
                                .catch((err) => {
                                    reject(err)
                                })
                        }
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        };

        return new Promise((resolve, reject) => {
            getPriceChunk()
                .then(res => {
                    if (context.state.outHotelMode) {
                        sendParams = sendParams.replace("RemoteHotelMode=0", "RemoteHotelMode=2");
                        durationIndex = 0;

                        getPriceChunk()
                            .then(res2 => {
                                resolve(res2)
                            })
                            .catch((err) => {
                                reject(err)
                            })
                    } else {
                        resolve(res)
                    }
                })
                .catch((err) => {
                    reject(err)
                })
        });
    },
    [types.A_SET_PRICE_TABLE](context, payload) {
        let origin = context.state.lastRequest.split("?")[0];
        let sendParams = context.state.lastRequest.split("?")[1].split("&");
        if (payload) {
            const tourDate = payload.date;
            const tourDuration = payload.duration;
            const cityFrom = payload.cityFrom;
            const cityTo = payload.cityTo;
            let dateReplace = false;
            let durationReplace = false;
            let cityFromReplace = false;
            let cityToReplace = false;

            sendParams = sendParams.filter(x => {
                if (x.includes("Dates") && !dateReplace) {
                    dateReplace = true
                    return x
                }
                if (x.includes("Durations") && !durationReplace) {
                    durationReplace = true
                    return x
                }
                if (cityFrom !== -2 && x.includes("DepartureCityKeys") && !cityFromReplace) {
                    cityFromReplace = true
                    return x
                } else if (cityFrom === -2 && x.includes("DepartureCityKeys")) {
                    return x
                }
                if (cityTo === -1 && x.includes("CityIds") && !cityToReplace) {
                    cityToReplace = true
                    return x
                } else if (cityTo === -1 && x.includes("CityIds")) {
                    return x
                }

                if (!x.includes("Dates") && !x.includes("Durations") &&
                    !x.includes("DepartureCityKeys") && !x.includes("CityIds")) {
                    return x
                }
            });
            sendParams = sendParams.map(x => {
                if (x.includes("Dates")) {
                    x = `Dates=${tourDate}`
                }
                if (x.includes("Durations")) {
                    x = `Durations=${tourDuration}`
                }
                if (cityFrom !== -2 && x.includes("DepartureCityKeys")) {
                    x = `DepartureCityKeys=${cityFrom}`
                }
                if (cityTo !== -1 && x.includes("CityIds")) {
                    x = `CityIds=${cityTo}`
                } else if (x.includes("CityIds")) {
                    x = null
                }
                return x
            });
            sendParams = sendParams.filter(x => x);
            if (!sendParams.includes("CityIds")) {
                sendParams.push(`CityIds=${cityTo}`)
            }
            sendParams = origin + "?" + sendParams.join("&");
        } else {
            let oldParams = context.state.mainRequest.split("?")[1];
            oldParams = oldParams.split("CurrencyName")[0];
            let afterCurrency = false;
            sendParams = sendParams.filter(x => {
                if (x.includes("CurrencyName")) {
                    afterCurrency = true
                }
                if (afterCurrency && !x.includes("CityIds")) {
                    return x;
                }
            }).join("&");
            sendParams = origin + "?" + oldParams + sendParams;
            // sendParams = origin +"?"+ sendParams.join("&");
        }
        // sendParams = encodeURI(sendParams);
        return new Promise((resolve, reject) => {
            Vue.Api.Get(sendParams)
                .then(res => {
                    const isOutSystem = context.state.outHotelMode;
                    context.state.lastRequest = sendParams;

                    context.state.searchResult = res.data.Result;
                    context.state.searchResult = context.state.searchResult.map(x => {
                        x.rate = context.getters['getRate'];
                        return x
                    });
                    context.state.secondaryFiltersResult = res.data.SecondaryFiltersResult;
                    context.state.searchedSecondFilters = true;
                    this.dispatch("tour/A_SET_SEARCHED", true);

                    if (isOutSystem) {
                        sendParams = sendParams.replace("RemoteHotelMode=0", "RemoteHotelMode=2");
                        Vue.Api.Get(sendParams)
                            .then(res => {
                                const rate = JSON.parse(localStorage.getItem("Rate"));
                                let resultGroup = [...context.state.searchResult, ...res.data.Result];
                                resultGroup = this.getters['quicksort'](resultGroup, "Cost");
                                resultGroup = resultGroup.map(x => {
                                    x.rate = {...rate};
                                    return x
                                });

                                let currentFilters = {...context.state.secondaryFiltersResult};
                                let newFilters = {...res.data.SecondaryFiltersResult};
                                let resultFilters = {};
                                for (let item in currentFilters) {
                                    newFilters[item] = newFilters[item].filter(x => {
                                        if (!currentFilters[item].map(x2 => x2.Key).includes(x.Key)) {
                                            return x
                                        }
                                    });
                                    let arr = [...currentFilters[item], ...newFilters[item]];
                                    resultFilters[item] = arr
                                }
                                context.state.searchResult = resultGroup;
                                context.state.secondaryFiltersResult = resultFilters;
                                resolve(res.data)
                            })
                            .catch((err) => {
                                reject(err)
                            })
                    } else {
                        resolve(res.data)
                    }
                })
                .catch((err) => {
                    reject(err)
                })
        });
    },
    [types.A_SET_SEARCH_SECOND_PARAMS](context, data) {
        context.state.filterParams = data
        const computedCityKey = context.state.tourSearchData.resort && context.state.tourSearchData.easySearchFilters ? "cityKeysOfResorts" : "citiesTo";

        let current = new Date().getTime();
        let flightNoTransfer = false;
        let flightNumberTransfer = null;
        if (data.tourTransplantation.length) {
            flightNoTransfer = data.tourTransplantation.map(x => x.value).includes(0);
            flightNumberTransfer = data.tourTransplantation.map(x => x.value).reduce((accum, val) => accum + val);
        }

        let flightNoTransferArrival = false;
        let flightNumberTransferArrival = null;
        if (data.tourTransplantationArrival.length) {
            flightNoTransferArrival = data.tourTransplantationArrival.map(x => x.value).includes(0);
            flightNumberTransferArrival = data.tourTransplantationArrival.map(x => x.value).reduce((accum, val) => accum + val);
        }

        let combineAirlines = data.tourAirlineMulty;


        context.state.searchId++;
        context.state.urlParams = context.state.urlParams.replace(/hotelQuota=\d/, `hotelQuota=${data.hotelQuota}`)
            .replace(/aviaQuota=\d/, `aviaQuota=${data.aviaQuota}`)
            .replace(/busTransferQuota=\d/, `busTransferQuota=${data.busTransferQuota}`)
            .replace(/trainTransferQuota=\d/, `trainTransferQuota=${data.railwayTransferQuota}`);

        const rate = JSON.parse(localStorage.getItem("Rate"))

        context.state.urlParams = context.state.urlParams.split("&").map(x => {
            if (x.includes("currency")) {
                x = `currency=${rate.IsoCode}`
            }
            return x
        }).join("&");

        const tourFoodKeys = data.tourFood.map(x => x.Key).flat(Infinity);
        const tourCategoryKeys = data.tourCategory.map(x => x.Key).flat(Infinity);
        const roomFeaturesKeys = data.roomFeatures.map(x => x.Key).flat(Infinity);

        let hotels = [...data.tourHotel];
        if (data.tourMapHotel.length) {
            hotels = [];
            data.tourMapHotel.forEach(x => {
                const hasHotel = hotels.map(x2 => x2.Key).includes(x.Key);
                if (!hasHotel) {
                    hotels.push(x)
                }
            });
        }

        // const mainFilterHotel = context.state.urlParams
        //     .split("&")
        //     .find(x => x.includes("hotels="))?.split("=")?.[1];
        // if (mainFilterHotel) {
        //     const hasHotel = hotels.map(x2 => x2.Key).includes(+mainFilterHotel);
        //     if (!hasHotel) {
        //         hotels.push({Key: +mainFilterHotel})
        //     }
        // }
        let resorts = [...data.tourResort];
        // const mainFilterResort = context.state.urlParams
        //     .split("&")
        //     .find(x => x.includes("resorts="))?.split("=")?.[1];
        // if (mainFilterResort) {
        //     const hasResort = resorts.map(x2 => x2.Key).includes(+mainFilterResort);
        //     if (!hasResort) {
        //         resorts.push({Key: +mainFilterResort})
        //     }
        // }
        let cities = [...data.tourCities];
        // const mainFilterCity = context.state.urlParams
        //     .split("&")
        //     .find(x => x.includes("cities="))?.split("=")?.[1];
        // if (mainFilterCity) {
        //     const hasCity = cities.map(x2 => x2.Key).includes(+mainFilterCity);
        //     if (!hasCity) {
        //         cities.push({Key: +mainFilterCity})
        //     }
        // }

        let urlParams = (hotels.length ? `&hotels=${hotels.map(x => x.Key).join(",")}` : "") +
            (data.tourMapHotel.length ? `&hotelOnMap=${data.tourMapHotel.map(x => x.Key).join(",")}` : "") +
            (tourCategoryKeys.length ? `&cats=${tourCategoryKeys.map(x => x).join(",")}` : "") +
            (cities.length && cities.every(x => x.Key !== "-1") ? `&cities=${cities.map(x => x.Key).join(",")}` : "") +
            (data.tourHotelType.length ? `&hotelTypes=${data.tourHotelType.map(x => x.key).join(",")}` : "") +
            (tourFoodKeys.length ? `&pansions=${tourFoodKeys.map(x => x).join(",")}` : "") +
            (resorts.length ? `&resorts=${resorts.map(x => x.Key).join(",")}` : "") +
            (data.tourAirlines.length ? `&airlines=${data.tourAirlines.map(x => x.Code).join(",")}` : "") +
            (data.tourAirlineMulty ? `&combineAirlines=true` : "") +
            (data.tourDepartureAirports.length ? `&dep_airports=${data.tourDepartureAirports.map(x => x.Code).join(",")}` : "") +
            (data.tourArrivalAirports.length ? `&arr_airports=${data.tourArrivalAirports.map(x => x.Code).join(",")}` : "") +
            (flightNoTransfer ? "&dTransfer=true" : "") +
            (flightNoTransferArrival ? "&aTransfer=true" : "") +
            (data.departureTime.length ? `&depTimeFrom=${data.departureTime[0]}&depTimeTo=${data.departureTime[1]}` : "") +
            (data.arrivalTime.length ? `&arrTimeFrom=${data.arrivalTime[0]}&arrTimeTo=${data.arrivalTime[1]}` : "") +
            (data.tourProgram.length ? `&tours=${data.tourProgram.map(x => x.Key).join(",")}` : "") +
            (data.minPrice ? `&minPrice=${data.minPrice}` : "") +
            (data.maxPrice ? `&maxPrice=${data.maxPrice}` : "") +
            (data.tourClass.length ? `&flightTariffs=${data.tourClass.map(x => x.Key).join(",")}` : "") +
            (data.tourClassMulty ? `&combineTariffs=true` : "") +
            (flightNumberTransfer ? `&departureFlightNumberTransfer=${flightNumberTransfer}` : "") +
            (flightNumberTransferArrival ? `&arrivalFlightNumberTransfer=${flightNumberTransferArrival}` : "") +
            (data.roomFeatures.length ? `&maskKeys=${data.roomFeatures.map(x => x.Key).join(",")}` : "") +
            (data.tourHotelTypeCombination ? `&hotelSignCombination=${data.tourHotelTypeCombination}` : "") +
            (data.tourHotelCombination ? `&hotelCombination=${data.tourHotelCombination}` : "");
        let sendParams = context.state.API_URL + 'TourForWeb/search/simple?' +
            context.state.tourSearchData.cities.map(x => `DepartureCityKeys=${x}`).join("&") + "&" +
            (data.currentDate ? `Dates=${data.currentDate}` : context.state.tourSearchData.date.map(x => `Dates=${x}`).join("&")) + "&" +
            (data.currentDuration ? `Durations=${data.currentDuration}` : context.state.tourSearchData.days.map(x => `Durations=${x}`).join("&")) + "&" +
            `PageNumber=${context.state.tourSearchData.page}&` +
            `PageSize=${context.state.tourSearchData.perPage}&` +
            "HotelScheme=&TourKey=&TourDuration=&ShowToursWithoutHotels=-1&isFromBasket=false&isFillSecondaryFilters=false&DestinationType=1&" +
            "DestinationKey=" + context.state.tourSearchData.countryTo + "&" +
            `AdultCount=${context.state.tourSearchData.adultCount}&` +
            context.state.tourSearchData.children.map(x => `ChildAges=${x.age}`).join("&") + "&" +
            `CurrencyName=${rate.Code}&` +
            `AviaQuota=${data.aviaQuota}&` +
            `HotelQuota=${data.hotelQuota}&` +
            `BusTransferQuota=${data.busTransferQuota}&` +
            `RailwayTransferQuota=${data.railwayTransferQuota}&` +
            (data.minPrice ? `MinPrice=${data.minPrice}&` : "") +
            (data.maxPrice ? `MaxPrice=${data.maxPrice}&` : "") +
            context.state.tourSearchData.tourType.map(x => `TourType=${x}`).join("&") + "&" +
            data.tourCities.map(x => `HotelCity=${x.Key}`).join("&") + "&" +
            data.tourHotelType.map(x => `HotelType=${x.key}`).join("&") + "&" +
            cities.map(x => `CityIds=${x.Key}`).join("&") + "&" +
            data.tourProgram.map(x => `Tour=${x.Key}`).join("&") + "&" +
            resorts.map(x => `HotelResort=${x.Key}`).join("&") + "&" +
            (!data.tourCities.length ? context.state.tourSearchData[computedCityKey].map(x => `CityIds=${x}`).join("&") + "&" : "") +
            tourCategoryKeys.map(x => `HotelStars=${x}`).join("&") + "&" +
            roomFeaturesKeys.map(x => `MaskKeys=${x}`).join("&") + "&" +
            hotels.map(x => `Hotel=${x.Key}`).join("&") + "&" +
            (data.tourHotelTypeCombination ? `HotelSignCombination=${data.tourHotelTypeCombination}&` : "") +
            (data.tourHotelCombination ? `HotelCombination=${data.tourHotelCombination}&` : "") +
            tourFoodKeys.map(x => `Pansions=${x}`).join("&") + "&" +
            data.tourAirlines.map(x => `Airline=${x.Code}`).join("&") + "&" +
            (combineAirlines ? "CombineAirlines=true&" : "") +
            data.tourDepartureAirports.map(x => `AirportDeparture=${x.Code}`).join("&") + "&" +
            data.tourArrivalAirports.map(x => `AirportArrival=${x.Code}`).join("&") + "&" +
            `TimeDepartureFrom=${data.departureTime[0] ? data.departureTime[0] : '00:00'}&` +
            `TimeDepartureTo=${data.departureTime[1] ? data.departureTime[1] : '23:59'}&` +
            `TimeArrivalFrom=${data.arrivalTime[0] ? data.arrivalTime[0] : '00:00'}&` +
            `TimeArrivalTo=${data.arrivalTime[1] ? data.arrivalTime[1] : '23:59'}&` +
            (flightNoTransferArrival ? "ArrivalFlightNoTransfer=true&" : "") +
            (flightNumberTransferArrival ? `ArrivalFlightNumberTransfer=${flightNumberTransferArrival}&` : "") +
            (flightNoTransfer ? "DepartureFlightNoTransfer=true&" : "") +
            (flightNumberTransfer ? `DepartureFlightNumberTransfer=${flightNumberTransfer}&` : "") +
            data.tourClass.map(x => `Tariff=${x.Key}`).join("&") + "&" +
            (data.tourClassMulty ? (`CombineTariffs=${data.tourClassMulty}` + "&") : "") +
            `SearchId=${context.state.searchId}&` +
            "wrongLicenseFileUpperTitle=Incorrect+license+file.&RemoteHotelMode=0&_=" + current;
        sendParams = sendParams.replace(/&+/g, "&")
        context.state.lastRequest = sendParams;

        // sendParams = encodeURI(sendParams);

        let firstQuestion = new Promise((resolve) => {
            Vue.Api.Get(sendParams)
                .then(res => {
                    resolve(res.data)
                });
        });
        let secondQuestion = new Promise((resolve) => {
            if (!context.state.outHotelMode) {
                resolve(null);
                return;
            }
            sendParams = sendParams.replace("RemoteHotelMode=0", "RemoteHotelMode=2")
            Vue.Api.Get(sendParams)
                .then(res => {
                    resolve(res.data)
                });
        });

        // context.state.commonSearchFlag = false; // Нужно для проверки запуска функции commonSearch
        return new Promise((resolve) => {
            Promise.all([firstQuestion, secondQuestion]).then(res => {
                let currentUrl = context.state.urlParams
                    .replace(/&hotels=\d+/, "")
                    .replace(/&resorts=\d+/, "")
                    .replace(/&cities=\d+/, "")

                let finalUrl = currentUrl + urlParams;

                context.state.searchSecondParamsCounter++;
                if (context.state.firstSearch) context.state.searchSecondParamsCounter++;

                if (window.settings.commonFilters) {
                  if (context.state.searchSecondParamsCounter === 1 && context.state.clickSearch) context.state.showTourResultList = true;
                } else {
                  context.state.showTourResultList = true
                }

                if (!res[1]) {
                    if (!window.settings.commonFilters 
                       || window.settings.commonFilters && context.state.searchSecondParamsCounter === 1 && context.state.clickSearch
                       || context.state.firstSearchWithParams && !context.state.firstSearch
                       || window.settings.commonFilters && context.state.convertPriceFlag) {

                        context.state.searchResult = res[0].Result.map(x => {
                        x.rate = rate;
                        return x
                        });

                        context.state.clickSearch = false
                        context.state.firstSearch = false;
                        context.state.firstSearchWithParams = false;
                        context.commit(mutation_types.M_SET_CONVERT_PRICE_FLAG, false)
                    }

                    if (!data.tourMapHotel.length)
                        context.state.secondaryFiltersResult = res[0].SecondaryFiltersResult;

                    context.state.searchedSecondFilters = true;
                    this.dispatch("tour/A_SET_SEARCHED", true);

                    resolve(finalUrl);
                    return
                }

                let resultGroup = [...res[0].Result, ...res[1].Result];
                resultGroup = this.getters['quicksort'](resultGroup, "Cost");
                resultGroup = resultGroup.map(x => {
                    x.rate = {...rate};
                    return x
                });

                if (!window.settings.commonFilters 
                   || window.settings.commonFilters && context.state.searchSecondParamsCounter === 1 && context.state.clickSearch
                   || window.settings.commonFilters && context.state.searchOutHotelFlag
                   || context.state.firstSearchWithParams && !context.state.firstSearch
                   || window.settings.commonFilters && context.state.convertPriceFlag)  {

                     context.state.searchResult = resultGroup;

                     context.state.clickSearch = false;
                     context.state.firstSearch = false;
                     context.state.firstSearchWithParams = false;
                     context.state.searchOutHotelFlag = false;
                     context.commit(mutation_types.M_SET_CONVERT_PRICE_FLAG, false)
                }

                let currentFilters = {...res[0].SecondaryFiltersResult};
                let newFilters = {...res[1].SecondaryFiltersResult};
                let resultFilters = {};
                for (let item in currentFilters) {
                    newFilters[item] = newFilters[item].filter(x => {
                        if (!currentFilters[item].map(x2 => x2.Key).includes(x.Key)) {
                            return x
                        }
                    });
                    let arr = [...currentFilters[item], ...newFilters[item]];
                    resultFilters[item] = arr
                }

                if (!data.tourMapHotel.length)
                    context.state.secondaryFiltersResult = resultFilters;

                context.state.searchedSecondFilters = true;
                this.dispatch("tour/A_SET_SEARCHED", true);

                resolve(finalUrl)
            })
        })
    },
    [types.A_CHANGE_SECOND_FILTER](context, data) {
        let current = new Date().getTime();
        let flightNoTransfer = false;
        let flightNumberTransfer = null;
        if (data.tourTransplantation.length) {
            flightNoTransfer = data.tourTransplantation.map(x => x.value).includes(0);
            flightNumberTransfer = data.tourTransplantation.map(x => x.value).reduce((accum, val) => accum + val);
        }
        let combineAirlines = data.tourAirlinesMulty;
        context.state.searchId++;
        let children = context.state.tourSearchData.children;

        const tourFoodKeys = data.tourFood.map(x => x.Key).flat(Infinity);
        const tourCategoryKeys = data.tourCategory.map(x => x.Key).flat(Infinity);

        let sendParams = context.state.API_URL + 'TourForWeb/search/simple?' +
            context.state.tourSearchData.cities.map(x => `DepartureCityKeys=${x}`).join("&") + "&" +
            context.state.tourSearchData.date.map(x => `Dates=${x}`).join("&") + "&" +
            context.state.tourSearchData.days.map(x => `Durations=${x}`).join("&") + "&" +
            `PageNumber=${context.state.tourSearchData.page}&` +
            `PageSize=${context.state.tourSearchData.perPage}&` +
            "HotelScheme=&TourKey=&TourDuration=&ShowToursWithoutHotels=-1&isFromBasket=false&isFillSecondaryFilters=false&DestinationType=1&" +
            "DestinationKey=" + context.state.tourSearchData.countryTo + "&" +
            `AdultCount=${context.state.tourSearchData.adultCount}` + "&" +
            ( children ? children.map(x => `ChildAges=${x.age}`).join("&") + "&" : "" )+
            `CurrencyName=${context.getters['getRate'].Code}&` +
            `AviaQuota=${data.AviaQuota}&` +
            `HotelQuota=${data.HotelQuota}&` +
            `BusTransferQuota=${data.BusTransferQuota}&` +
            `RailwayTransferQuota=${data.RailwayTransferQuota}&` +
            (data.price[0] ? `MinPrice=${data.price[0]}&` : "") +
            (data.price[1] ? `MaxPrice=${data.price[1]}&` : "") +
            context.state.tourSearchData.tourType.map(x => `TourType=${x}`).join("&") + "&" +
            data.tourCities.map(x => `HotelCity=${x.Key}`).join("&") + "&" +
            data.tourHotelType.map(x => `HotelType=${x.key}`).join("&") + "&" +
            data.tourCities.map(x => `CityIds=${x.Key}`).join("&") + "&" +
            data.tourProgram.map(x => `Tour=${x.Key}`).join("&") + "&" +
            data.tourResort.map(x => `HotelResort=${x.Key}`).join("&") + "&" +
            (!data.tourCities.length ? context.state.tourSearchData.citiesTo.map(x => `CityIds=${x}`).join("&") + "&" : "") +
            tourCategoryKeys.map(x => `HotelStars=${x}`).join("&") + "&" +
            data.tourHotel.map(x => `Hotel=${x.Key}`).join("&") + "&" +
            tourFoodKeys.map(x => `Pansions=${x}`).join("&") + "&" +
            data.tourAirlines.map(x => `Airline=${x.Code}`).join("&") + "&" +
            (combineAirlines ? "CombineAirlines=true&" : "") +
            data.tourDepartureAirports.map(x => `AirportDeparture=${x.Code}`).join("&") + "&" +
            data.tourArrivalAirports.map(x => `AirportArrival=${x.Code}`).join("&") + "&" +
            `TimeDepartureFrom=${data.departureTime[0] ? data.departureTime[0] : '00:00'}&` +
            `TimeDepartureTo=${data.departureTime[1] ? data.departureTime[1] : '23:59'}&` +
            `TimeArrivalFrom=${data.arrivalTime[0] ? data.arrivalTime[0] : '00:00'}&` +
            `TimeArrivalTo=${data.arrivalTime[1] ? data.arrivalTime[1] : '23:59'}&` +
            (flightNoTransfer ? "ArrivalFlightNoTransfer=true&" : "") +
            (flightNumberTransfer ? `ArrivalFlightNumberTransfer=${flightNumberTransfer}&` : "") +
            (flightNoTransfer ? "DepartureFlightNoTransfer=true&" : "") +
            (flightNumberTransfer ? `DepartureFlightNumberTransfer=${flightNumberTransfer}&` : "") +
            data.tourClass.map(x => `Tariff=${x.Key}`).join("&") + "&" +
            (data.tourClassMulty ? (`CombineTariffs=${data.tourClassMulty}` + "&") : "") +
            `SearchId=${context.state.searchId}&` +
            "wrongLicenseFileUpperTitle=Incorrect+license+file.&RemoteHotelMode=0&_=" + current;
        sendParams = sendParams.replace(/&+/g, "&")

        // sendParams = encodeURI(sendParams)
        let firstQuestion = new Promise((resolve) => {
            Vue.Api.Get(sendParams)
                .then(res => {
                    // context.state.secondaryFiltersResult = res.data.SecondaryFiltersResult;
                    resolve(res.data.SecondaryFiltersResult)
                });
        });
        let secondQuestion = new Promise((resolve) => {
            if (!context.state.outHotelMode) {
                resolve(null);
                return;
            }
            sendParams = sendParams.replace("RemoteHotelMode=0", "RemoteHotelMode=2")
            Vue.Api.Get(sendParams)
                .then(res => {
                    resolve(res.data.SecondaryFiltersResult)
                });
        });

        return new Promise((resolve) => {
            Promise.all([firstQuestion, secondQuestion]).then(res => {
                if (res[1] === null) {
                    context.state.secondaryFiltersResult = {...res[0]};
                    resolve();
                    return
                }
                let currentFilters = {...res[0]};
                let newFilters = {...res[1]};
                let resultFilters = {};
                for (let item in currentFilters) {
                    newFilters[item] = newFilters[item].filter(x => {
                        if (!currentFilters[item].map(x2 => x2.Key).includes(x.Key)) {
                            return x
                        }
                    });
                    resultFilters[item] = [...currentFilters[item], ...newFilters[item]]
                }
                context.state.secondaryFiltersResult = {...resultFilters};
                resolve()
            })
        })
    },
    [types.A_SET_HOTEL_DETAILS](context, data) {
        const rate = data.rateCode;
        const fromBasket = data.fromBasket;
        if (!data.Services.length) {
            return new Promise((resolve, reject) => {
                reject(true)
            })
        }
        let searchMode = this.getters['getSettings'];
        searchMode = searchMode.TourSearchMode === 2;

        let current = new Date().getTime();

        let scheme = [];
        let duration = data.Duration;
        for (let i = 0; i < data.MinCostServicesComposition.length; i++) {
            if (data.MinCostServicesComposition[i].Value.ServiceType === 3) {
                scheme.push({
                    TemplateId: data.MinCostServicesComposition[i].Key.TemplateId,
                    TotalTourDuration: data.Duration,
                    DurationInNight: data.MinCostServicesComposition[i].Value.DurationInNight,
                    Code: data.MinCostServicesComposition[i].Value.Code,
                    PacketKey: data.MinCostServicesComposition[i].Value.PacketId,
                    PartnerKey: data.MinCostServicesComposition[i].Value.PartnerId,
                    Http: data.MinCostServicesComposition[i].Value.Http || null,
                    GDSProviderId: data.MinCostServicesComposition[i].Value.GDSProviderId
                })
            }
        }
        if (searchMode && scheme.length) {
            //Необходимо суммировать duration из всех схем отелей и передавать на бэк, т.к. настройка того требует
            duration = 1;

            scheme.forEach(x => {
                duration += x.DurationInNight;
            })
        }

        scheme = JSON.stringify(scheme);
        // scheme = encodeURIComponent(scheme);
        let startDate = data.StartDate.split("T")[0].split("-");
        startDate[0] = startDate[0].slice(2);
        startDate = startDate.reverse().join(".");


        let tourSearchData = context.state.tourSearchData
        if (fromBasket) {
            tourSearchData = fromBasket
        }

        let hotelsKeys=context.state.filterParams.tourHotel.map(x => `Hotel=${x.Key}`).join("&");

        if(data.hotels)
        {
            if(data.hotels.length==1)
            {
                hotelsKeys=data.hotels.map(x => `Hotel=${x.Hotel.Key}`).join("&");
            }
        }

        const pansionKeys = context.state.filterParams.tourFood.map(x => x.Key).flat();
        const pansions = pansionKeys.map(x => `Pansions=${x}`).join("&");
        const roomFeaturesKeys = context.state.filterParams.roomFeatures.map(x => x.Key).flat();
        const tourCategoryKeys = context.state.filterParams.tourCategory.map(x => x.Key).flat(Infinity);

        let sendParams = context.state.API_URL + 'TourForWeb/search/simple?' +
            `DepartureCityKeys=${data.CityDepature.Key}&` +
            `Dates=${startDate}&` +
            `Durations=${duration}&` +
            `PageNumber=${tourSearchData.page}&` +
            `PageSize=1000&` +
            `HotelScheme=${scheme}&` +
            `TourKey=${data.Key}&` +
            `TourDuration=${duration}&` +
            `ShowToursWithoutHotels=-1&isFromBasket=false&isFillSecondaryFilters=false&DestinationType=1&` +
            "DestinationKey=" + tourSearchData.countryTo + "&" +
            `AdultCount=${tourSearchData.adultCount}` + "&" +
            (tourSearchData.children ? tourSearchData.children.map(x => `ChildAges=${x.age}`).join("&") + "&" : "") +
            `CurrencyName=${rate}&` +
            `AviaQuota=${context.state.filterParams.aviaQuota}&` +
            `HotelQuota=${context.state.filterParams.hotelQuota}&` +
            `BusTransferQuota=${context.state.filterParams.busTransferQuota}&` +
            `RailwayTransferQuota=${context.state.filterParams.railwayTransferQuota}&` +
            (data.Types.length ? data.Types.map(x => `TourType=${x}`).join("&") + "&" : "TourType=-1&") +
            context.state.filterParams.tourCities.map(x => `HotelCity=${x.key}`).join("&") + "&" +
            context.state.filterParams.tourHotelType.map(x => `HotelType=${x.key}`).join("&") + "&" +
            context.state.filterParams.tourCities.map(x => `CityIds=${x.Key}`).join("&") + "&" +
            context.state.filterParams.tourProgram.map(x => `Tour=${x.Key}`).join("&") + "&" +
            context.state.filterParams.tourResort.map(x => `HotelResort=${x.Key}`).join("&") + "&" +
            (!context.state.filterParams.tourCities.length ? tourSearchData.citiesTo.map(x => `CityIds=${x}`).join("&") + "&" : "") +
            tourCategoryKeys.map(x => `HotelStars=${x}`).join("&") + "&" +
            hotelsKeys + "&" +
            pansions + "&" +
            // context.state.filterParams.tourFood.map(x => `Pansions=${x.Key}`).join("&") + "&" +
            context.state.filterParams.tourAirlines.map(x => `Airline=${x.Code}`).join("&") + "&" +
            context.state.filterParams.tourDepartureAirports.map(x => `AirportDeparture=${x.Code}`).join("&") + "&" +
            context.state.filterParams.tourArrivalAirports.map(x => `AirportArrival=${x.Code}`).join("&") + "&" +
            `TimeDepartureFrom=${context.state.filterParams.departureTime[0] ? context.state.filterParams.departureTime[0] : '00:00'}&` +
            `TimeDepartureTo=${context.state.filterParams.departureTime[1] ? context.state.filterParams.departureTime[1] : '23:59'}&` +
            `TimeArrivalFrom=${context.state.filterParams.arrivalTime[0] ? context.state.filterParams.arrivalTime[0] : '00:00'}&` +
            `TimeArrivalTo=${context.state.filterParams.arrivalTime[1] ? context.state.filterParams.arrivalTime[0] : '23:59'}&` +
            context.state.filterParams.tourClass.map(x => `Tariff=${x.Key}`).join("&") + "&" +
            (context.state.filterParams.tourClassMulty ? (`CombineTariffs=${context.state.filterParams.tourClassMulty}` + "&") : "") +
            `SearchId=${context.state.searchId}&` +
            roomFeaturesKeys.map(x => `MaskKeys=${x}`).join("&") + "&" +
            "wrongLicenseFileUpperTitle=Incorrect+license+file.&_=" + current;
        sendParams = sendParams.replace(/&+/g, "&")
        if (fromBasket) {
            sendParams = sendParams.split("&").map(x => {
                if (x.includes("CurrencyName=")) {
                    x = `CurrencyName=${fromBasket.currency}`
                }
                return x
            });
            sendParams = sendParams.join("&");
        }

        // sendParams = encodeURI(sendParams)
        return new Promise((resolve) => {
            Vue.Api.Get(sendParams)
                .then(res => {
                    resolve(res)
                });
        });
    },
    [types.A_GET_NEXT_PAGE](context, payload) {
        const page = payload.page;
        const isLocal = payload.isLocal;
        const loadAll = payload.loadAll;
        const rate = JSON.parse(localStorage.getItem("Rate"));
        const current = new Date().getTime();
        let sendParams = context.state.lastRequest.replace(/PageNumber=\d/, `PageNumber=${page}`);
        sendParams = sendParams.replace(/&_=\d*/, `&_=${current}`);
        sendParams = sendParams.split("&").map(x => {
            if (x.includes('CurrencyName')) {
                x = `CurrencyName=${rate.Code}`
            }
            return x
        });
        sendParams = sendParams.join("&");

        if (context.getters.getCollapse) {
          sendParams = sendParams.replace("simple", "map");
          sendParams = sendParams + "&Groups=32"
        }

        // sendParams = encodeURI(sendParams);
        let firstQuestion = new Promise((resolve) => {
            if (!isLocal && !loadAll) {
                resolve(null);
                return;
            }

            Vue.Api.Get(sendParams)
                .then(res => {
                    resolve(res)
                });
        });
        let secondQuestion = new Promise((resolve) => {
            if (!context.state.outHotelMode || isLocal && !loadAll) {
                resolve(null);
                return;
            }

            sendParams = sendParams.replace("RemoteHotelMode=0", "RemoteHotelMode=2");
            Vue.Api.Get(sendParams)
                .then(res => {
                    resolve(res)
                });
        });

        return new Promise((resolve) => {
            Promise.all([firstQuestion, secondQuestion]).then(res => {
                if (!res[1] && res[0]) {
                    if (context.getters.getCollapse) {
                      let collapseByHotel = [...(res[0].data.SearchForMap || res[0].data.Result)];
                      collapseByHotel = collapseByHotel.map(x => {
                        x.rate = {...rate};
                        return x
                      });
                      context.state.searchResult = context.state.searchResult.concat(collapseByHotel)
                    } else {
                      res[0].data.Result.forEach(x => {
                        context.state.searchResult.push(x)
                    });
                    }
                    resolve(res[0]);
                    return
                }
                if (!res[0] && res[1]) {
                    if (context.getters.getCollapse) {
                      res[1].data.SearchForMap.forEach(x => {
                        context.state.searchResult.push(x)
                    });
                    } else {
                      res[1].data.Result.forEach(x => {
                        context.state.searchResult.push(x)
                    });
                   }
                    resolve(res[1]);
                    return
                }

                res[0].data.Result.forEach(x => {
                    context.state.searchResult.push(x)
                });

                res[1].data.Result.forEach(x => {
                    context.state.searchResult.push(x)
                });
                // let resultGroup = [...context.state.searchResult, ...res[0].data.Result, ...res[1].data.Result];
                // resultGroup = resultGroup.map(x => {
                //     x.rate = {...rate};
                //     return x
                // });
                // resultGroup = this.getters['quicksort'](resultGroup, "Cost");
                // context.state.searchResult = [...resultGroup];
                let result = {
                    data: {
                        Result: [...res[0].data.Result, ...res[1].data.Result]
                    }
                };
                resolve(result)
            })
        })
    },
    [types.A_COLLAPSE](context, payload) {
        context.commit(mutation_types.M_COLLAPSE_BY_HOTEL, payload)
    },
    [types.A_COLLAPSE_BY_HOTEL](context, payload) {
        const rate = JSON.parse(localStorage.getItem("Rate"));

        let sendParams = context.state.lastRequest;

        if (!payload) {
            let chunks = sendParams.split('PageNumber=');
            sendParams = chunks[0] + "Groups=32&" + 'PageNumber=1' + chunks[1].slice(1);
            sendParams = sendParams.replace("simple", "map");
        }
        const firstQuestion = new Promise((resolve) => {
            Vue.Api.Get(sendParams).then(res => {
                context.commit(mutation_types.M_COLLAPSE_BY_HOTEL, !payload)
                resolve(res)
            })
        });
        const secondQuestion = new Promise((resolve) => {
            if (!context.state.outHotelMode) {
                resolve({ data: {SearchForMap: []} });
                return
            }
            sendParams = sendParams.replace("RemoteHotelMode=0", "RemoteHotelMode=2");
            Vue.Api.Get(sendParams).then(res => {
                resolve(res)
            })
        });
        return new Promise((resolve) => {
            Promise.all([firstQuestion, secondQuestion]).then(res => {
                context.state.searchResult =
                    [...(res[0].data.SearchForMap || res[0].data.Result), ...(res[1].data.SearchForMap || res[1].data.Result)];

                context.state.searchResult = context.state.searchResult.map(x => {
                    x.rate = {...rate};
                    return x
                });
                resolve()
            })
        })
    },
    [types.A_GET_HOTELS_FOR_MAP](context) {
        const _this = this;

        let sendParams = context.state.lastRequest;
        let chunks = sendParams.split('PageNumber=');
        sendParams = chunks[0] + "Groups=32&" + 'PageNumber=' + chunks[1];
        sendParams = sendParams.replace("simple", "map");
        sendParams = sendParams.split("&");
            // .replace(/&Hotel=[\d+,]+/, "");

        const href = window.location.href.split("&");
        const hasHotelsInHref = href.find(x => x.includes("hotels="));
        sendParams = sendParams.filter(x => !x.includes("Hotel="));

        if (hasHotelsInHref) {
            const hotels = hasHotelsInHref
                .split("=")[1]
                .split(",");

            hotels.forEach(x => {
                sendParams.push(`Hotel=${x}`)
            })
        }
        sendParams = sendParams.join("&");

        if (context.state.lastMapRequest === sendParams) {
            return
        }
        context.commit(mutation_types.M_SET_LAST_MAP_REQUEST, sendParams);

        Get(sendParams)
            .then(res => {
                setMapItems(res, 0)
            });

        if (!context.state.outHotelMode) {
            return
        }
        sendParams = sendParams.replace("RemoteHotelMode=0", "RemoteHotelMode=2");
        Get(sendParams)
            .then(res => {
                setMapItems(res, 1)
            });

        function setMapItems(res, type) {
            const date = new Date().getTime();
            let items = [...res.data.SearchForMap];
            const keys = items
                .map(x => x.Services.filter(x => x.SvKey === 3))
                .filter(x => x.length)
                .map(x => x[0].Hotel.Key);

            let hotelKeys = keys.map(x => `hotelKeys=${x}`);
            hotelKeys = new Set(hotelKeys);
            hotelKeys = Array.from(hotelKeys).join("&");

            Vue.Api.Get(context.state.API_URL + `HotelImages?${hotelKeys}&_=${date}`)
                .then(res2 => {
                    items = items.map(x => {
                        const path = _this.getters['getPath'];
                        const hotels = x.Services.find(x2 => x2.SvKey === 3);
                        if (hotels) {
                            const hotelKey = hotels.Hotel.Key;
                            const image = res2.data.find(x2 => x2.HotelKey === hotelKey);

                            x.mainImg = `${context.state.API_ORIGIN}${path}/Image/GetImage?code=${hotelKey}&type=medium&name=${image.Name}&imageType=hotels`;
                        }

                        return x
                    });

                    context.commit(mutation_types.M_SET_HOTELS_FOR_MAP, {
                        items,
                        type
                    })
                });
        }
    },
    [types.A_SET_SEARCH_IN_OUT](context, payload) {
        context.commit(mutation_types.M_SET_SEARCH_IN_OUT, payload)
    },
    [types.A_SET_API_URL](context, payload) {
        context.commit(mutation_types.M_SET_API_URL, payload)
    },
    [types.A_SET_API_ORIGIN](context, payload) {
        context.commit(mutation_types.M_SET_API_ORIGIN, payload)
    },
    [types.A_GET_CO_INFO](context, payload) {
        const sendData = `COKeysString=${payload}`;

        return new Promise((resolve) => {
            Vue.Api.Get(`${context.state.API_URL}CostOfferDescriptions?${sendData}`)
                .then(res => {
                    resolve(res)
                })
        })
    },
    [types.A_GET_CO_IMAGE_INFO](context, payload) {
        const Path = payload.Path;
        const IdCostOffer = payload.IdCostOffer;
        const InfoText = payload.InfoText;
        const width = payload.width || "50";
        const height = payload.height || "50";
        

        return new Promise((resolve) => {
            Vue.Api.Get(`${Path}/GetImage/GetCostOfferFile?&id=${IdCostOffer}&width=${width}&height=${height}&text=${InfoText}`)
                .then(res => {
                    resolve(res)
                })
        })
    },
    [types.A_GET_CO_IMAGES](context, payload) {
        const Path = payload.Path;
        const Keys = payload.Keys;

        return new Promise((resolve) => {
            Vue.Api.Post(`${Path}/GetImage/GetCostOfferFiles?&ids=${Keys}`)
                .then(res => {
                    resolve(res)
                })
        })
    },
    [types.A_GET_TRANSPORT_SEATS_INFO](context, payload) {
        const date = new Date().getTime();
        const sendData = `code=${payload.code}&` +
            `dateBegin=${payload.dateBegin}&` +
            `serviceType=${payload.serviceType}&` +
            `transportKey=${payload.transportKey}&` +
            `_=${date}`;

        return new Promise((resolve) => {
            Vue.Api.Get(`${context.state.API_URL}TransportPlan?${sendData}`)
                .then(res => {
                    resolve(res.data)
                })
        })
    },
    [types.A_GET_COUNTRY_INFO](context, payload) {
        const date = new Date().getTime();
        const sendData = `countryKey=${payload}&` +
            `_=${date}`;

        return new Promise((resolve) => {
            Vue.Api.Get(`${context.state.API_URL}CountryInfo?${sendData}`)
                .then(res => {
                    resolve(res.data)
                })
        })
    },
    [types.A_SEARCH_COMBO](context, payload) {
        return new Promise((resolve) => {
            const arr = [
                {id: 1, text: "asd"},
                {id: 2, text: "qwerty"},
                {id: 3, text: "asd2"},
                {id: 4, text: "asd3"},
                {id: 5, text: "afj"},
                {id: 90, text: "Австрия"},
            ];
            resolve(arr.filter(x => x.text.toLowerCase().includes(payload.toLowerCase())));
            // const sendParams = `${context.state.API_URL}CountryInfo?${payload}`;
            // Get(sendParams)
            //     .then(res => {
            //         resolve(res)
            //     });
        })
    },
};
